/*
 * @Description: 正则
 * @Autor: tanglitong
 * @Date: 2020-05-01 11:09:54
 * @LastEditors: tanglitong
 * @LastEditTime: 2020-07-02 14:17:49
 */
// 数字正则
export const numberReg = /^[0-9]*$/
// 身份证正则
export const idCardReg =
  /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)/
// 男性身份证正则
export const menIdCardReg =
  /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[1|3|5|7|9][0-9Xx]$)/
// 女性身份证正则
export const womenIdCardReg =
  /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0|2|4|6|8][0-9Xx]$)/
// 出生证正则
export const birthCertificate = /^[A-Z][0-9]{9}$/
// 其他证件号正则
export const otherCertificate = /^[A-z0-9]*$/
//手机号
// export const phoneReg =
//   /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[01235678]|18[0-9]|19[13589])\d{8}$/;
export const phoneReg =
  /^1[3-9]\d{9}$/
//固定电话
export const mobileReg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/
//税号只能输入15 18 20位
export const taxReg = /^([0-9A-Za-z]{15}|[0-9A-Za-z]{18}|[0-9A-Za-z]{20})$/
//邮箱正则
export const emailReg =
  /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
//金额正则
export const amountReg =
  /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/

// 任意字符(除空格)8-16位长度
export const PasswordLengthRge = /^.{8,16}$/

// 至少包含一个大写字母和一个小写字母
export const UppercaseLowercaseReg = /(?=.*[a-z])(?=.*[A-Z])/g

// 包含数字
export const NumberReg = /\d+/

// 特殊字符
export const SpecialCharactersReg = /[-/:;()$&@.,?!‘’[\]{}#%^*+=_\|~<>\\•]/

// 8-16位之间、包含大小写、包含数字、包含特殊字符
export const PasswordReg =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-/:;()$&@.,?!‘’[\]{}#%^*+=_\|~<>\\•])[a-zA-Z0-9-/:;()$&@.,?!‘’[\]{}#%^*+=_\|~<>\\•]{8,16}$/g

// 6位数字
export const CodeReg = /^[0-9]{6}$/

// 开头为字母6-20位(用户名)
export const userNameReg = /^[a-zA-Z][a-zA-Z0-9]{5,19}$/



// WEBPACK FOOTER //
// ./src/utils/commonReg.js